// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import MatiereProfileLayout from './MatiereProfileLayout';

import MatiereService from '../../services/MatiereService';

const DeleteMatiere = () => {
	const [student, setStudent] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([MatiereService.getMatiere(id)]).then(([matiereData]) => {
			setStudent(matiereData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the MatiereService to delete the student
			await MatiereService.deleteMatiere(id);

			// Redirect the user to the list of students
			navigate('/pedagogie/matieres');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations de la matier",
				error
			);
		}
	};

	return (
		<MatiereProfileLayout>
			{student && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{student.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cette Matiere.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez cette Matiere, toutes les données la concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer la Matiere
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</MatiereProfileLayout>
	);
};

export default DeleteMatiere;
